import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-white-button',
    templateUrl: './white-button.component.html',
    styleUrls: ['./white-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WhiteButtonComponent {
    @Input()
    label: string = '';

    @Input()
    labelTranslateParams: Record<string, unknown> | null = null;

    @Input()
    icon: string = '';

    @Input()
    svgIcon: string = '';

    @Input()
    disabled: boolean = false;

    @Input()
    isActive: boolean = false;

    @Input()
    showThreeDots: boolean = false;

    @Input()
    counter: number = 0;

    @Input()
    isRounded: boolean = false;

    @Input()
    showArrowRight: boolean = false;

    @Input()
    showArrowDown: boolean = false;

    @Input()
    isLoading: boolean = false;

    @Input()
    fullWidth: boolean = false;

    @Input()
    forceTrailingIconOnRight: boolean = false;

    /** When true, leading icon uses neutral fill styling (#ADAFB3); use with a filled Material icon glyph (e.g. remove_circle). */
    @Input()
    mutedSolidIcon: boolean = false;

    @Output()
    onClick = new EventEmitter<any>();

    constructor() {}

    onClickButton(event): void {
        this.onClick.emit(event);
    }
}
